module.exports = __webpack_public_path__ + "fcb70649d060962db0e560440c78c631.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/booking_holdings_2021_chart.png
// module id = 1640
// module chunks = 0